export default __webpack_public_path__ + "static/son-tung-c452c3d31c88a8ccbb67089047086319.jpeg";